import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { FiMenu } from "react-icons/fi";

import SidePanel, { MenuItem } from "../components/SidePanel/SidePanel";
import Logo from "../components/Logo/Logo";

const RegisterLayout = () => {
  const [sidebarVisible, setSidebarVisible] = useState(false);

  // Handle sidebar toggle
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  // Close sidebar when screen size changes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Define menu items for the register layout - just one item
  const menuItems: MenuItem[] = [
    { description: "Register", href: "/user/register" },
  ];

  return (
    <>
      <main className="mainContainer">
        {/* Overlay for mobile when sidebar is open */}
        {sidebarVisible && (
          <div
            className="md:hidden sidebar-overlay"
            onClick={toggleSidebar}
            aria-hidden="true"
          ></div>
        )}

        {/* Always render the sidebar but control its visibility with CSS */}
        <SidePanel
          menuItems={menuItems}
          onCloseMobile={toggleSidebar}
          isVisible={sidebarVisible}
        />

        <div id="contentContainer" className="absolute inset-0 left-0 ">
          <div id="header" className="fixed z-40 right-0 left-0 ">
            <div className="bg-black h-[73px] flex items-center">
              <button
                onClick={toggleSidebar}
                className="md:hidden text-white p-2 ml-2 focus:outline-none"
                aria-label="Toggle sidebar"
              >
                <FiMenu size={24} />
              </button>

              {/* Logo - show only on mobile */}
              <div className="flex-grow flex justify-center">
                <Logo showOnlyOnMobile />
              </div>
            </div>
          </div>
          <div id="content" className="absolute inset-0 mt-[73px]">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};

export default RegisterLayout;
